module.exports = __webpack_public_path__ + "img/weip.3dfb9393.webp";